import React from "react";
import PageContainer from "@jumbo/components/PageComponents/layouts/PageContainer";
import IntlMessages from "@jumbo/utils/IntlMessages";
import FillFormDetails from "@jumbo/Dashboards/FormBuilder/FillFormDetails/FillFormDetails";

const breadcrumbs = [
  { label: <IntlMessages id={"sidebar.main"} />, link: "/" },
  { label: <IntlMessages id={"pages.forms"} />, link: "/forms" },
  {
    label: <IntlMessages id={"pages.formInputsFillDetails"} />,
    isActive: true,
  },
];

const FormInputFillDetails = () => {
  return (
    <PageContainer
      heading={<IntlMessages id="pages.formInputsFillDetails" />}
      breadcrumbs={breadcrumbs}
    >
      <FillFormDetails />
    </PageContainer>
  );
};

export default FormInputFillDetails;
